import { render } from "./NewsLetter.vue?vue&type=template&id=22f1cc1e"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__